import React from "react";
import { Box, Typography, Link } from "@mui/material";

function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: "#0A192F",
        color: "white",
        py: 3,
        mt: 6,
        textAlign: "center",
      }}
    >
      <Typography variant="body1">
        © {new Date().getFullYear()} Arocoiris Tech. All rights reserved.
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Link href="/privacy" color="inherit" underline="hover" sx={{ mx: 1 }}>
          Privacy Policy
        </Link>
        <Link href="/terms" color="inherit" underline="hover" sx={{ mx: 1 }}>
          Terms of Service
        </Link>
      </Box>
    </Box>
  );
}

export default Footer;